import { useBreakpoints } from '@/shared/providers/Device';
import { ArticleCtaStoryblok } from '@/shared/types/storyblok/storyblok-types';
import { storyblokEditable } from '@storyblok/react';
import Container from '../Container/Container';
import styles from './ArticleCta.module.scss';
import Author from './_component/Author/Author';
import FeaturedBlog from './_component/FeaturedBlog/FeaturedBlog';
import FeaturedProject from './_component/FeaturedProject/FeaturedProject';

const useIsMobile = (): boolean => {
    const { isXXSmall, isExtraSmall, isSmall } = useBreakpoints();
    return isXXSmall || isExtraSmall || isSmall;
};

const FeaturedContent: React.FC<{ item: any; isMobile: boolean }> = ({ item, isMobile }) => {
    switch (item?.content?.component) {
        case 'projects':
            return <FeaturedProject featuredProject={item} />;
        default:
            return <FeaturedBlog featuredBlog={item} isMobile={isMobile} />;
    }
};
const ArticleCta = ({ blok }: ArticleCtaStoryblok) => {
    const { authorTitle, author, featuredContent, button, buttonColor, anchor } = blok ?? {};
    const isMobile = useIsMobile();

    return (
        <div {...storyblokEditable(blok)} id={anchor}>
            <Container code="large" className={{ wrap: styles.wrapper, root: styles.root }} blok={blok}>
                <Author
                    authorTitle={authorTitle}
                    author={author}
                    isMobile={isMobile}
                    ctaButtonGroup={button}
                    color={buttonColor}
                />

                {(featuredContent?.[0] || featuredContent?.[1]) && (
                    <div className={styles.content}>
                        <FeaturedContent item={featuredContent?.[0]} isMobile={isMobile} />
                        <div className={styles.splitter} />
                        <FeaturedContent item={featuredContent?.[1]} isMobile={isMobile} />
                    </div>
                )}
            </Container>
        </div>
    );
};

export default ArticleCta;
